import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { CustomerService } from './customer.service';
import { ErrorService } from './error.service';
import { UserService } from './user.service';

@Injectable()
export class TrackOrderService {

	constructor(private _http: HttpClient,
				private _errorService: ErrorService,
				private _sanitizer: DomSanitizer,
				private _userService: UserService,
				private _customerService: CustomerService) {
	}

	buildShipment(shipment, user) {
		return new Promise((resolve, reject) => {
			this.getDetails(shipment.type, shipment.id).subscribe((response) => {
				const shipmentDetails = response;
				shipmentDetails.shipmentSummary = shipment;
				shipmentDetails.formattedSignature = this._sanitizer.bypassSecurityTrustUrl('data:image/svg+xml;base64,' + shipmentDetails.signature);
				shipmentDetails.driverPhotos?.forEach(driver => {
					if (driver.photo) {
						driver.rawPhoto = driver.photo;
						driver.photo = this._sanitizer.bypassSecurityTrustUrl('data:image/jpeg;base64,' + driver.photo);
					}
				});
				resolve(shipmentDetails);
			}, (error) => {
				reject();
				this._errorService.error(error, 'getDetails Failed', 'modal');
			});
		});
	}

	/**
	 * @api {get} /v2/Shipments/Details Get Shipment Details
	 * @apiName trackOrders
	 * @apiParam {string} [shipmentType] Shipment Type
	 * @apiParam {number} [pkId] PKID
	 * @apiGroup Shipments
	 * @apiVersion 20.0.0
	 */
	getDetails(shipmentType, id) {
		let params: HttpParams = new HttpParams();
		params = params.append('shipmentType', shipmentType);
		params = params.append('pkId', id);
		return this._http.get<any>(`${environment.apiUrl}/v2/Shipments/Details`, {params});
	}

	/**
	 * @api {get} /v2/Drivers/:id/Photo Get Driver Photo
	 * @apiName getDriverPhoto
	 * @apiGroup Drivers
	 * @apiVersion 20.0.0
	 */
	getDriverPhoto(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Drivers/${id}/Photo`);
	}

	/**
	 * @api {post} /v2/Shipments/Summaries Track Orders
	 * @apiName trackOrders
	 * @apiParam {string} [trackingType] Tracking Type
	 * @apiParam {string} [beginDate] Begin Date
	 * @apiParam {string} [endDate] End Date
	 * @apiParam {boolean} [includePartialMatch] Include Partial Match
	 * @apiParam {number} [numRecentOrders] Number of Recent Orders
	 * @apiParam {number} [pageNum] Page Number
	 * @apiParam {number} [pageSize] Page Size
	 * @apiGroup Shipments
	 * @apiVersion 20.0.0
	 */
	trackOrders(
		trackingType,
		trackingRequest,
		beginDate,
		endDate,
		partialMatch,
		numRecentOrders,
		pageNum,
		pageSize,
		customerId
	) {
		if (trackingRequest) {
			// Because a perfectly good array as a post body is to much to ask for :p
			// So we have to turn the array to a comma separated string
			trackingRequest = JSON.stringify(trackingRequest.join(', '));
		}
		let params: HttpParams = new HttpParams();
		params = params.append('trackingType', trackingType);
		if (beginDate) {
			params = params.append('beginDate', beginDate);
		}
		if (endDate) {
			params = params.append('endDate', endDate);
		}
		if (partialMatch) {
			params = params.append('includePartialMatch', partialMatch);
		}
		if (numRecentOrders) {
			params = params.append('numRecentOrders', numRecentOrders);
		}
		if (pageNum) {
			params = params.append('pageNum', pageNum);
		}
		if (pageSize) {
			params = params.append('pageSize', pageSize);
		}
		if (customerId) {
			params = params.append('customerId', customerId);
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/Shipments/Summaries`, trackingRequest, {params});
	}

	driverTrackingAllowed() {
		// Permission spaghetti, return false if any of these are true
		// The inet user is set to Disabled
		// The inet user is set to "Use Customer" and the Customer is set to "Disabled"
		// The inet user is set to "Use Customer", the Customer is set to "Use Global" and Global is set to "Disabled"
		// The inet user is set to "Use Global" and the Global is set to "Disabled"
		const user = this._userService.getUser();
		const selectedCustomer = this._customerService.getSelectedCustomer();
		if (user?.inetUser?.driverLocationDisplayAccessibility === 'DISABLED') {
			return false;
		} else if (user?.inetUser?.driverLocationDisplayAccessibility === 'USE_CUSTOMER' && selectedCustomer?.driverLocationDisplayAccessibility === 'DISABLED') {
			return false;
		} else if (user?.inetUser?.driverLocationDisplayAccessibility === 'USE_CUSTOMER' && selectedCustomer?.driverLocationDisplayAccessibility === 'USE_GLOBAL' &&
			user?.globalSettings?.driverLocationDisplayAccessibility === 'DISABLED') {
			return false;
		}else if (user?.inetUser?.driverLocationDisplayAccessibility === 'USE_GLOBAL' && user?.globalSettings?.driverLocationDisplayAccessibility === 'DISABLED') {
			return false;
		} else {
			return true;
		}
	}
}
